/**
 * Float Label Pattern Plugin for Bootstrap 3.1.0 by Travis Wilson
 */
(function($) {
	$.fn.floatLabels = function (options) {

		// Settings
		var self = this;
		// let settings = $.extend({}, options);


		// Event Handlers
		function registerEventHandlers() {
			self.on('input keyup change', 'input, textarea', function () {
				actions.swapLabels(this);
				if ($(this).val() !== '') {
					$(this).addClass('filled');
				} else {
					$(this).removeClass('filled');
				}
			});
		}


		// Actions
		let actions = {
			initialize: function() {
				self.each(function() {
					let $this = $(this);
					let $label = $this.children('label');
					let $field = $this.find('input,textarea').first();

					if ($this.children().first().is('label')) {
						$this.children().first().remove();
						$this.append($label);
					}

					let placeholderText = ($field.attr('placeholder') && $field.attr('placeholder') !== $label.text()) ? $field.attr('placeholder') : $label.text();

					$label.data('placeholder-text', placeholderText);
					$label.data('original-text', $label.text());

					if ($field.val() !== '') {
						$field.addClass('filled')
					}
				});
			},
			swapLabels: function(field) {
				let $field = $(field);
				let $label = $(field).siblings('label').first();
				let isEmpty = Boolean($field.val());

				if (isEmpty) {
					$field.removeClass('empty');
					$label.text($label.data('original-text'));
				} else {
					$field.addClass('empty');
					$label.text($label.data('placeholder-text'));
				}
			}
		}


		// Initialization
		function init() {
			registerEventHandlers();

			actions.initialize();
			self.each(function () {
				actions.swapLabels($(this).find('input,textarea').first());
			});
		}
		init();


		return this;
	};

	$(function() {
		$('.float-label-control').floatLabels();
	});
})(jQuery);
